export default "__VITE_ASSET__BYhWMxmA__"